"use client"
import { MantineProvider } from '@mantine/core';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
      <div><MantineProvider>{children}</MantineProvider></div>
  );
}